import { createFileRoute, redirect, notFound } from '@tanstack/react-router';
import { SidebarLayout } from '@/components/layout/SidebarLayout';
import { navigationConfig } from '@/utils/navigation';
import { useNavigationItems } from '@/hooks/useNavigation';
import { useTranslation } from 'react-i18next';
import { canAccessAdminArea } from '@/utils/authz';

/**
 * Admin area route. Allowed global roles: ADMIN and DEVELOPER ({@link canAccessAdminArea}).
 */
export const Route = createFileRoute('/admin')({
  component: AdminLayout,
  beforeLoad: ({ context, location }) => {
    // Redirect to login if unauthenticated
    if (!context?.auth) {
      throw redirect({
        to: '/login',
        search: { redirect: location.href } as any,
      });
    }

    const { role } = context.auth || {};
    // Only allow users with role 'ADMIN' 
    if (!canAccessAdminArea(role)) {
      throw notFound();
    }
  },
});

/**
 * Admin layout using sidebar navigation with dynamic module integration.
 * Sidebar navigation config is loaded from navigationConfig.admin and merged with enabled modules.
 */
function AdminLayout() {
  const config = navigationConfig.admin;
  const navigationItems = useNavigationItems('admin');
  const { t } = useTranslation('navigation');

  return (
    <SidebarLayout
      context="admin"
      title={t(config.titleKey)}
      navigationItems={navigationItems}
      expandedSiderWidth={config.expandedWidth}
      collapsedSiderWidth={config.collapsedWidth}
    />
  );
}
